export var LanguageCodeType = /*#__PURE__*/function (LanguageCodeType) {
  LanguageCodeType["arSA"] = "ar-SA";
  LanguageCodeType["bgBG"] = "bg-BG";
  LanguageCodeType["caES"] = "ca-ES";
  LanguageCodeType["zhTW"] = "zh-TW";
  LanguageCodeType["csCZ"] = "cs-CZ";
  LanguageCodeType["daDK"] = "da-DK";
  LanguageCodeType["deDE"] = "de-DE";
  LanguageCodeType["elGR"] = "el-GR";
  LanguageCodeType["enUS"] = "en-US";
  LanguageCodeType["es"] = "es";
  LanguageCodeType["fiFI"] = "fi-FI";
  LanguageCodeType["frFR"] = "fr-FR";
  LanguageCodeType["heIL"] = "he-IL";
  LanguageCodeType["huHU"] = "hu-HU";
  LanguageCodeType["isIS"] = "is-IS";
  LanguageCodeType["itIT"] = "it-IT";
  LanguageCodeType["jaJP"] = "ja-JP";
  LanguageCodeType["koKR"] = "ko-KR";
  LanguageCodeType["nlNL"] = "nl-NL";
  LanguageCodeType["nbNO"] = "nb-NO";
  LanguageCodeType["plPL"] = "pl-PL";
  LanguageCodeType["ptBR"] = "pt-BR";
  LanguageCodeType["rmCH"] = "rm-CH";
  LanguageCodeType["roRO"] = "ro-RO";
  LanguageCodeType["ruRU"] = "ru-RU";
  LanguageCodeType["hrHR"] = "hr-HR";
  LanguageCodeType["skSK"] = "sk-SK";
  LanguageCodeType["sqAL"] = "sq-AL";
  LanguageCodeType["svSE"] = "sv-SE";
  LanguageCodeType["thTH"] = "th-TH";
  LanguageCodeType["trTR"] = "tr-TR";
  LanguageCodeType["urPK"] = "ur-PK";
  LanguageCodeType["idID"] = "id-ID";
  LanguageCodeType["ukUA"] = "uk-UA";
  LanguageCodeType["beBY"] = "be-BY";
  LanguageCodeType["slSI"] = "sl-SI";
  LanguageCodeType["etEE"] = "et-EE";
  LanguageCodeType["lvLV"] = "lv-LV";
  LanguageCodeType["ltLT"] = "lt-LT";
  LanguageCodeType["tgCyrlTJ"] = "tg-Cyrl-TJ";
  LanguageCodeType["faIR"] = "fa-IR";
  LanguageCodeType["viVN"] = "vi-VN";
  LanguageCodeType["hyAM"] = "hy-AM";
  LanguageCodeType["azLatnAZ"] = "az-Latn-AZ";
  LanguageCodeType["euES"] = "eu-ES";
  LanguageCodeType["hsbDE"] = "hsb-DE";
  LanguageCodeType["mkMK"] = "mk-MK";
  LanguageCodeType["tnZA"] = "tn-ZA";
  LanguageCodeType["xhZA"] = "xh-ZA";
  LanguageCodeType["zuZA"] = "zu-ZA";
  LanguageCodeType["afZA"] = "af-ZA";
  LanguageCodeType["kaGE"] = "ka-GE";
  LanguageCodeType["foFO"] = "fo-FO";
  LanguageCodeType["hiIN"] = "hi-IN";
  LanguageCodeType["mtMT"] = "mt-MT";
  LanguageCodeType["seNO"] = "se-NO";
  LanguageCodeType["msMY"] = "ms-MY";
  LanguageCodeType["kkKZ"] = "kk-KZ";
  LanguageCodeType["kyKG"] = "ky-KG";
  LanguageCodeType["swKE"] = "sw-KE";
  LanguageCodeType["tkTM"] = "tk-TM";
  LanguageCodeType["uzLatnUZ"] = "uz-Latn-UZ";
  LanguageCodeType["ttRU"] = "tt-RU";
  LanguageCodeType["bnIN"] = "bn-IN";
  LanguageCodeType["paIN"] = "pa-IN";
  LanguageCodeType["guIN"] = "gu-IN";
  LanguageCodeType["orIN"] = "or-IN";
  LanguageCodeType["taIN"] = "ta-IN";
  LanguageCodeType["teIN"] = "te-IN";
  LanguageCodeType["knIN"] = "kn-IN";
  LanguageCodeType["mlIN"] = "ml-IN";
  LanguageCodeType["asIN"] = "as-IN";
  LanguageCodeType["mrIN"] = "mr-IN";
  LanguageCodeType["saIN"] = "sa-IN";
  LanguageCodeType["mnMN"] = "mn-MN";
  LanguageCodeType["boCN"] = "bo-CN";
  LanguageCodeType["cyGB"] = "cy-GB";
  LanguageCodeType["kmKH"] = "km-KH";
  LanguageCodeType["loLA"] = "lo-LA";
  LanguageCodeType["chrCherUS"] = "chr-Cher-US";
  LanguageCodeType["iuCansCA"] = "iu-Cans-CA";
  LanguageCodeType["glES"] = "gl-ES";
  LanguageCodeType["kokIN"] = "kok-IN";
  LanguageCodeType["syrSY"] = "syr-SY";
  LanguageCodeType["siLK"] = "si-LK";
  LanguageCodeType["amET"] = "am-ET";
  LanguageCodeType["neNP"] = "ne-NP";
  LanguageCodeType["fyNL"] = "fy-NL";
  LanguageCodeType["psAF"] = "ps-AF";
  LanguageCodeType["filPH"] = "fil-PH";
  LanguageCodeType["dvMV"] = "dv-MV";
  LanguageCodeType["haLatnNG"] = "ha-Latn-NG";
  LanguageCodeType["yoNG"] = "yo-NG";
  LanguageCodeType["quzBO"] = "quz-BO";
  LanguageCodeType["nsoZA"] = "nso-ZA";
  LanguageCodeType["baRU"] = "ba-RU";
  LanguageCodeType["lbLU"] = "lb-LU";
  LanguageCodeType["klGL"] = "kl-GL";
  LanguageCodeType["igNG"] = "ig-NG";
  LanguageCodeType["tiET"] = "ti-ET";
  LanguageCodeType["hawUS"] = "haw-US";
  LanguageCodeType["iiCN"] = "ii-CN";
  LanguageCodeType["arnCL"] = "arn-CL";
  LanguageCodeType["mohCA"] = "moh-CA";
  LanguageCodeType["brFR"] = "br-FR";
  LanguageCodeType["ugCN"] = "ug-CN";
  LanguageCodeType["miNZ"] = "mi-NZ";
  LanguageCodeType["ocFR"] = "oc-FR";
  LanguageCodeType["coFR"] = "co-FR";
  LanguageCodeType["gswFR"] = "gsw-FR";
  LanguageCodeType["sahRU"] = "sah-RU";
  LanguageCodeType["qutGT"] = "qut-GT";
  LanguageCodeType["rwRW"] = "rw-RW";
  LanguageCodeType["woSN"] = "wo-SN";
  LanguageCodeType["prsAF"] = "prs-AF";
  LanguageCodeType["gdGB"] = "gd-GB";
  LanguageCodeType["kuArabIQ"] = "ku-Arab-IQ";
  LanguageCodeType["arIQ"] = "ar-IQ";
  LanguageCodeType["caESvalencia"] = "ca-ES-valencia";
  LanguageCodeType["zhCN"] = "zh-CN";
  LanguageCodeType["deCH"] = "de-CH";
  LanguageCodeType["enGB"] = "en-GB";
  LanguageCodeType["esMX"] = "es-MX";
  LanguageCodeType["frBE"] = "fr-BE";
  LanguageCodeType["itCH"] = "it-CH";
  LanguageCodeType["nlBE"] = "nl-BE";
  LanguageCodeType["nnNO"] = "nn-NO";
  LanguageCodeType["ptPT"] = "pt-PT";
  LanguageCodeType["ruMO"] = "ru-MO";
  LanguageCodeType["srLatnCS"] = "sr-Latn-CS";
  LanguageCodeType["svFI"] = "sv-FI";
  LanguageCodeType["azCyrlAZ"] = "az-Cyrl-AZ";
  LanguageCodeType["dsbDE"] = "dsb-DE";
  LanguageCodeType["tnBW"] = "tn-BW";
  LanguageCodeType["seSE"] = "se-SE";
  LanguageCodeType["gaIE"] = "ga-IE";
  LanguageCodeType["msBN"] = "ms-BN";
  LanguageCodeType["uzCyrlUZ"] = "uz-Cyrl-UZ";
  LanguageCodeType["bnBD"] = "bn-BD";
  LanguageCodeType["paArabPK"] = "pa-Arab-PK";
  LanguageCodeType["taLK"] = "ta-LK";
  LanguageCodeType["mnMongCN"] = "mn-Mong-CN";
  LanguageCodeType["sdArabPK"] = "sd-Arab-PK";
  LanguageCodeType["iuLatnCA"] = "iu-Latn-CA";
  LanguageCodeType["tzmLatnDZ"] = "tzm-Latn-DZ";
  LanguageCodeType["ffLatnSN"] = "ff-Latn-SN";
  LanguageCodeType["quzEC"] = "quz-EC";
  LanguageCodeType["tiER"] = "ti-ER";
  LanguageCodeType["arEG"] = "ar-EG";
  LanguageCodeType["zhHK"] = "zh-HK";
  LanguageCodeType["deAT"] = "de-AT";
  LanguageCodeType["enAU"] = "en-AU";
  LanguageCodeType["esES"] = "es-ES";
  LanguageCodeType["frCA"] = "fr-CA";
  LanguageCodeType["srCyrlCS"] = "sr-Cyrl-CS";
  LanguageCodeType["seFI"] = "se-FI";
  LanguageCodeType["quzPE"] = "quz-PE";
  LanguageCodeType["arLY"] = "ar-LY";
  LanguageCodeType["zhSG"] = "zh-SG";
  LanguageCodeType["deLU"] = "de-LU";
  LanguageCodeType["enCA"] = "en-CA";
  LanguageCodeType["esGT"] = "es-GT";
  LanguageCodeType["frCH"] = "fr-CH";
  LanguageCodeType["hrBA"] = "hr-BA";
  LanguageCodeType["smjNO"] = "smj-NO";
  LanguageCodeType["tzmTfngMA"] = "tzm-Tfng-MA";
  LanguageCodeType["arDZ"] = "ar-DZ";
  LanguageCodeType["zhMO"] = "zh-MO";
  LanguageCodeType["deLI"] = "de-LI";
  LanguageCodeType["enNZ"] = "en-NZ";
  LanguageCodeType["esCR"] = "es-CR";
  LanguageCodeType["frLU"] = "fr-LU";
  LanguageCodeType["bsLatnBA"] = "bs-Latn-BA";
  LanguageCodeType["smjSE"] = "smj-SE";
  LanguageCodeType["arMA"] = "ar-MA";
  LanguageCodeType["enIE"] = "en-IE";
  LanguageCodeType["esPA"] = "es-PA";
  LanguageCodeType["frMC"] = "fr-MC";
  LanguageCodeType["srSPCyrl"] = "sr-SP-Cyrl";
  LanguageCodeType["smaNO"] = "sma-NO";
  LanguageCodeType["arTN"] = "ar-TN";
  LanguageCodeType["enZA"] = "en-ZA";
  LanguageCodeType["esDO"] = "es-DO";
  LanguageCodeType["srCyrlBA"] = "sr-Cyrl-BA";
  LanguageCodeType["smaSE"] = "sma-SE";
  LanguageCodeType["arOM"] = "ar-OM";
  LanguageCodeType["enJM"] = "en-JM";
  LanguageCodeType["esVE"] = "es-VE";
  LanguageCodeType["bsCyrlBA"] = "bs-Cyrl-BA";
  LanguageCodeType["smsFI"] = "sms-FI";
  LanguageCodeType["arYE"] = "ar-YE";
  LanguageCodeType["en029"] = "en-029";
  LanguageCodeType["esCO"] = "es-CO";
  LanguageCodeType["srLatnRS"] = "sr-Latn-RS";
  LanguageCodeType["smnFI"] = "smn-FI";
  LanguageCodeType["arSY"] = "ar-SY";
  LanguageCodeType["enBZ"] = "en-BZ";
  LanguageCodeType["esPE"] = "es-PE";
  LanguageCodeType["srCyrlRS"] = "sr-Cyrl-RS";
  LanguageCodeType["arJO"] = "ar-JO";
  LanguageCodeType["enTT"] = "en-TT";
  LanguageCodeType["esAR"] = "es-AR";
  LanguageCodeType["srLatnME"] = "sr-Latn-ME";
  LanguageCodeType["arLB"] = "ar-LB";
  LanguageCodeType["enZW"] = "en-ZW";
  LanguageCodeType["esEC"] = "es-EC";
  LanguageCodeType["srCyrlME"] = "sr-Cyrl-ME";
  LanguageCodeType["arKW"] = "ar-KW";
  LanguageCodeType["enPH"] = "en-PH";
  LanguageCodeType["esCL"] = "es-CL";
  LanguageCodeType["arAE"] = "ar-AE";
  LanguageCodeType["esUY"] = "es-UY";
  LanguageCodeType["arBH"] = "ar-BH";
  LanguageCodeType["esPY"] = "es-PY";
  LanguageCodeType["arQA"] = "ar-QA";
  LanguageCodeType["enIN"] = "en-IN";
  LanguageCodeType["esBO"] = "es-BO";
  LanguageCodeType["enMY"] = "en-MY";
  LanguageCodeType["esSV"] = "es-SV";
  LanguageCodeType["enSG"] = "en-SG";
  LanguageCodeType["esHN"] = "es-HN";
  LanguageCodeType["esNI"] = "es-NI";
  LanguageCodeType["esPR"] = "es-PR";
  LanguageCodeType["esUS"] = "es-US";
  LanguageCodeType["cimode"] = "cimode";
  return LanguageCodeType;
}({});